import { render, staticRenderFns } from "./MemberCenter.vue?vue&type=template&id=3c5b0da5&scoped=true&"
import script from "./MemberCenter.vue?vue&type=script&lang=ts&"
export * from "./MemberCenter.vue?vue&type=script&lang=ts&"
import style0 from "./MemberCenter.vue?vue&type=style&index=0&id=3c5b0da5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b0da5",
  null
  
)

export default component.exports